import {
  EDITOR_CREATE_SNIPPET_SNAPSHOT_BEGIN,
  EDITOR_CREATE_SNIPPET_SNAPSHOT_SUCCESS,
  EDITOR_CREATE_SNIPPET_SNAPSHOT_FAILURE,
  EDITOR_CREATE_SNIPPET_SNAPSHOT_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import { toast } from 'react-toastify';
import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import { Mixpanel } from '../../../common/utils/mixpanelUtil';

export function createSnippetSnapshot(args = {}) {
  return (dispatch) => {
    dispatch({
      type: EDITOR_CREATE_SNIPPET_SNAPSHOT_BEGIN,
    });
    const { projectId, version, data } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.post(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/snippet-snapshots`,
        data,
        header,
      );
      doRequest.then(
        (res) => {
          if (res.status === 200 && res.data) {
            dispatch({
              type: EDITOR_CREATE_SNIPPET_SNAPSHOT_SUCCESS,
              data: res.data,
            });
            Mixpanel.track('Created Snippet Snapshot on builder', { uuid: res.data.uuid });
            toast.success('Snippet Snapshot Created Successfully !');
            resolve(res);
          } else {
            dispatch({
              type: EDITOR_CREATE_SNIPPET_SNAPSHOT_FAILURE,
              data: { error: 'Failed' },
            });
            Mixpanel.track('Failed to create Snippet Snapshot on builder');
            const errMsg = getErrorMessageFromResponse(res);
            toast.error(`Failed : ${errMsg}`, {});
            reject('Failed');
          }
        },
        (err) => {
          dispatch({
            type: EDITOR_CREATE_SNIPPET_SNAPSHOT_FAILURE,
            data: { error: err },
          });
          Mixpanel.track('Failed to create Snippet Snapshot on builder');
          const errMsg = getErrorMessageFromResponse(err.response);
          toast.error(`Failed : ${errMsg}`, {});
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissCreateSnippetSnapshotError() {
  return {
    type: EDITOR_CREATE_SNIPPET_SNAPSHOT_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case EDITOR_CREATE_SNIPPET_SNAPSHOT_BEGIN:
      return {
        ...state,
        createSnippetSnapshotPending: true,
        createSnippetSnapshotError: null,
      };

    case EDITOR_CREATE_SNIPPET_SNAPSHOT_SUCCESS:
      return {
        ...state,
        createSnippetSnapshotPending: false,
        createSnippetSnapshotError: null,
        snippetSnapshots: [...state.snippetSnapshots, action.data],
      };

    case EDITOR_CREATE_SNIPPET_SNAPSHOT_FAILURE:
      return {
        ...state,
        createSnippetSnapshotPending: false,
        createSnippetSnapshotError: action.data.error,
      };

    case EDITOR_CREATE_SNIPPET_SNAPSHOT_DISMISS_ERROR:
      return {
        ...state,
        createSnippetSnapshotError: null,
      };

    default:
      return state;
  }
}
